import { render, staticRenderFns } from "./RedirectLogin.vue?vue&type=template&id=76e9d876&"
import script from "./RedirectLogin.vue?vue&type=script&lang=js&"
export * from "./RedirectLogin.vue?vue&type=script&lang=js&"
import style0 from "./RedirectLogin.vue?vue&type=style&index=0&id=76e9d876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
